/**
 * Connectors Service — Report Templates API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ReportColumnMeta { 
    field?: string;
    type?: ReportColumnMeta.TypeEnum;
}
export namespace ReportColumnMeta {
    export const TypeEnum = {
        String: 'STRING',
        Number: 'NUMBER',
        Date: 'DATE',
        Datetime: 'DATETIME',
        Boolean: 'BOOLEAN'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


